import React from 'react';
import { Modal, Col, Row, Button } from 'react-bootstrap';
export const TemplateInfoModal = ({ show, onCancel }) => {
    return (
      <Modal
        show={show}
        centered
        dialogClassName="modal--confirmation"
        onHide={onCancel}
      >
        <div className="p-4">
            <h1>How To Use the Import Templates</h1>
            <ol>
              <li>Download the template</li>
              <li>Add data, one line per record to import</li>
              <li>Limit the uploaded file to a maximum of 10,000 rows</li>
            </ol>

            <h1>How to Associate Client Data to Clients</h1>

            <p>
              There are four optional columns in the template that are used to add data to clients:
              Client ID, Client First Name, Client Last Name, and Client Date of Birth.
            </p>

            <p>
              If you provide a Client ID (the SureImpact ID),
              the import tool will match on that.
            </p>

            <p>
              If no Client ID is provided, the import tool will attempt to lookup a client by
              first name and last name.  If there is one matching client, it'll add the data
              to that client.  If there are multiple matching clients, the import will
              try to find a match with the specified date of birth.
            </p>
            <Row className="text-center">
              <Col>
                <Button
                  onClick={onCancel}
                >
                  OK
                </Button>
              </Col>
            </Row>
          </div>
      </Modal>
    );
  }

export default TemplateInfoModal;
